module.exports = __webpack_public_path__ + "img/vertex.65d297b3.png";